/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Table, TableHead, TableRow, TableCell, TableBody, TableFooter } from '@material-ui/core';
import _ from 'lodash';
import moment from 'moment';
import { actions as budgetActions } from '../../actions/budgetActions';
import BudgetApplicationListOfSupportForm from './BudgetApplicationListOfSupportForm';
import Map from '../map/Map';
import numberFormatter from '../../utils/numberFormatter';

class BudgetApplicationListOfSupportPage extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();

    this.submitForm = this.submitForm.bind(this);
    this.state = {
      success: false,
      failure: false,
    };
  }

  componentDidMount() {
    this.props.actions.load()
      .then(_ => {
        this.props.actions.loadApplicationDetails(this.props.budget.id, this.props.applicationId);
      });
  }

  scrollToForm = () => this.formRef.current.scrollIntoView();

  createFormInitialState() {
    return {
      budgetId: this.props.budget.id,
      applicationId: this.props.applicationId,
    };
  }

  submitForm(data) {
    return this.props.actions.submitApplicationSupport(this.props.budget.id, this.props.applicationId, data)
      .then(result => {
        if (result) {
          this.setState({ success: true });
          return;
        }
        
        this.setState({ failure: true });
      });
  }

  confirmSubmitError = () => {
    window.location.href = 'https://' + window.location.host;
  }

  render() {
    const { budget, unit, applicationDetails, canSubmit } = this.props;
    const { success, failure } = this.state;

    const submittingDisabled = budget ? !moment().isBetween(moment(budget.applicationTemplate.eListOfSupport.startDate), moment(budget.applicationTemplate.eListOfSupport.endDate)) : false;

    return (<React.Fragment>
      <div key="top" className="row top">
        <div className="col-sm-5 d-flex align-items-end" />
        <div className="col-sm-7 header">
          <div className="budget-menu">
            <a href="/budzet-obywatelski" className="btn"><i className="fa fa-long-arrow-alt-left" /> powrót</a>
          </div>
        </div>
      </div>
      {!budget || !applicationDetails ? <div style={{ width: '100%', marginTop: 200, textAlign: 'center' }}><CircularProgress size={50} /></div> :
        <div key="content" style={{ marginTop: 40 }}>
          <div className="row">
            <div className="box-header-outside">
              <div className="col-sm-12">
                <div className="header">
                  <h2>Zgłoszenie poparcia dla projektu</h2>
                  {submittingDisabled
                    ? <p>Możliwość zgłaszania nie jest obecnie możliwa</p>
                    : <p style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => this.scrollToForm()}>Podpisz listę poparcia - zostało {moment(budget.applicationTemplate.eListOfSupport.endDate).toNow(true)}</p>}
                    <p>Zgłoszenie poparcia możliwe jest w terminie {moment(budget.applicationTemplate.eListOfSupport.startDate).format('YYYY-MM-DD HH:mm')} - {moment(budget.applicationTemplate.eListOfSupport.endDate).format('YYYY-MM-DD HH:mm')}</p>
                </div>
              </div>
            </div>

            {budget.applicationTemplate.form.map(item => (
              <div className="box" key={item.id}>
                <div className="col-sm-12">
                  <h3>{item.title}</h3>
                  {item.type === 'name'
                    ? <p>{applicationDetails.title}</p>
                    : null}
                  {item.type === 'description'
                    ? <p>{applicationDetails.fields.find(f => f.id === item.id).value}</p>
                    : null}
                  {item.type === 'location'
                    ? <React.Fragment>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell padding="none">Pełny adres</TableCell>
                              <TableCell size="small">Miejscowość</TableCell>
                              <TableCell padding="none">Opis</TableCell>
                              <TableCell size="small">Numer działki</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {applicationDetails.locations.map((location, index) => (
                              <TableRow key={index}>
                                <TableCell padding="none">
                                  {location.address}
                                </TableCell>
                                <TableCell size="small">
                                  {location.city}
                                </TableCell>
                                <TableCell padding="none">
                                  {location.description}
                                </TableCell>
                                <TableCell size="small">
                                  {location.plotNumber}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>

                        {applicationDetails.locations && applicationDetails.locations.length > 0 &&
                          <div style={{ marginTop: 16, height: 400 }}>
                            <Map
                              markers={applicationDetails.locations.filter(l => l.location && l.location.lat && l.location.lng).map((l, index) => ({ id: index, lat: l.location.lat, lng: l.location.lng, title: (l.address || l.city || l.plotNumber) }))}
                            />
                          </div>
                        }
                      </React.Fragment>
                    : null}
                  {item.type === 'costs'
                    ? <React.Fragment>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell padding="none" style={{ minWidth: 90 }}>Nazwa</TableCell>
                              <TableCell size="small" style={{ maxWidth: 90 }} >Jednostka miary<br />(np. metr, sztuka)</TableCell>
                              <TableCell padding="none" style={{ maxWidth: 120 }} align="right" >Cena jednostki</TableCell>
                              <TableCell size="small" align="right" style={{ maxWidth: 90 }}>Liczba jednostek<br />(np. 10 sztuk)</TableCell>
                              <TableCell padding="none" style={{ maxWidth: 120 }} align="right">Łączny koszt</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {applicationDetails.costs.map((cost, index) => (
                              <TableRow key={index}>
                                <TableCell padding="none">
                                  {cost.name}
                                </TableCell>
                                <TableCell size="small" >
                                  {cost.unit}
                                </TableCell>
                                <TableCell padding="none" align="right" >
                                  {numberFormatter.format(cost.price)} zł
                                </TableCell>
                                <TableCell size="small" align="right" >
                                  {cost.qty}
                                </TableCell>
                                <TableCell padding="none" align="right" style={{ alignItems: 'center' }}>
                                  {numberFormatter.format(cost.value)} zł
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                          <TableFooter>
                            <TableRow>
                              <TableCell padding="none" style={{ border: 'none' }} />
                              <TableCell size="small" style={{ border: 'none' }} />
                              <TableCell padding="none" align="right" style={{ border: 'none' }} />
                              <TableCell size="small" align="right" style={{ border: 'none' }} />
                              <TableCell padding="none" size="small" align="right" style={{ border: 'none' }}>{numberFormatter.format(_.sum(applicationDetails.costs.map(c => c.value)))} zł</TableCell>
                            </TableRow>
                          </TableFooter>
                        </Table>

                      </React.Fragment>
                    : null}
                </div>
              </div>
            ))}
          </div>
          <div ref={this.formRef} />
          {submittingDisabled
          ? null
          : 
          <BudgetApplicationListOfSupportForm
            applicationForm={budget.applicationTemplate.eListOfSupport}
            onSubmit={this.submitForm}
            initialValues={this.createFormInitialState()}
            disabled={this.props.preview}
            unit={unit}
            budget={budget}
            canSubmit={canSubmit}
          />}

        {budget.applicationTemplate.eListOfSupport.requiredDataPublic
          ? <React.Fragment>
            <div className="row">
              <div className="box-header-outside">
                <div className="col-sm-12">
                  <div className="header">
                    <h2>Ostatnie poparcia</h2>
                  </div>
                </div>
              </div>

              <div className="box">
                <div className="col-sm-12">
                  <Table>
                    <TableHead>
                      <TableRow>
                        {budget.applicationTemplate.eListOfSupport.requiredData.name ? <TableCell size="small">Imię</TableCell> : null}
                        {budget.applicationTemplate.eListOfSupport.requiredData.lastName ? <TableCell size="small">Nazwisko</TableCell> : null}
                        <TableCell size="small">Data</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                    {applicationDetails.supports.map((support, index) => (
                      <TableRow key={index}>
                        {budget.applicationTemplate.eListOfSupport.requiredData.name ? <TableCell size="small">{support.isPublic ? support.name : '-'}</TableCell> : null}
                        {budget.applicationTemplate.eListOfSupport.requiredData.lastName ? <TableCell size="small">{support.isPublic ? support.lastName : '-'}</TableCell> : null}
                        <TableCell size="small">{moment(support.createdAt).format('YYYY-MM-DD HH:mm')}</TableCell>
                      </TableRow>
                    ))}
                    </TableBody>
                  </Table>
                  <p style={{ marginTop: 16 }}>Całkowita liczba zebranych głosów poparcia: <strong>{applicationDetails.supportsCount}</strong></p>
                </div>
              </div>
            </div>
            </React.Fragment>
            : <p style={{ marginTop: 16 }}>Całkowita liczba zebranych głosów poparcia: <strong>{applicationDetails.supportsCount}</strong></p>}

          <Dialog open={success} aria-labelledby="dialog-title" maxWidth="md">
            <DialogTitle id="dialog-title">Dziękujemy za zgłoszone poparcie!</DialogTitle>
            <DialogContent>
              <p>Prosimy o śledzenie etapów zgodnie z harmonogramem.</p>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => { window.location.href = 'https://' + window.location.host; }} color="primary" variant="contained">
                Ok
            </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={failure} aria-labelledby="dialog-title" maxWidth="md">
            <DialogTitle id="dialog-title">Uwaga</DialogTitle>
            <DialogContent>
              <Typography variant="subtitle1">Wpisane dane zostały już wcześniej wykorzystane do zgłoszenia poparcia w aktualnym Budżecie. W celu wyjaśnień wątpliwości prosimy o kontakt z Urzędem - dane kontaktowe dostępne są w zakładce "Kontakt" na stronie głównej portalu.</Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.confirmSubmitError} color="primary" variant="contained">
                Ok
            </Button>
            </DialogActions>
          </Dialog>
        </div>}
    </React.Fragment>);
  }
}

BudgetApplicationListOfSupportPage.propTypes = {
  applicationForm: PropTypes.object,
  actions: PropTypes.object.isRequired,
  budget: PropTypes.object,
  preview: PropTypes.bool,
  cms: PropTypes.object.isRequired,
  unit: PropTypes.object.isRequired,
  applicationId: PropTypes.string,
  applicationDetails: PropTypes.object,
  canSubmit: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    applicationForm: state.form.applicationForm ? state.form.applicationForm.values : null,
    budget: state.budget.current,
    preview: window.location.href.includes('podglad'),
    cms: state.cms,
    unit: state.unit,
    applicationId: ownProps.match.params.id,
    applicationDetails: state.budgetApplicationDetails.data,
    canSubmit: state.budget.current
      ? (state.budget.current.isActive)
      : false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(budgetActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BudgetApplicationListOfSupportPage);

/*
obsluga ponownego glosu
*/


// WEBPACK FOOTER //
// ./src/components/budget/BudgetApplicationListOfSupportPage.js